// Define a default UI for filtering
import React from 'react'

export default function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  totalResults,
}) {
  const [value, setValue] = React.useState(globalFilter)
  React.useEffect(() => {
    setValue(globalFilter)
  }, [globalFilter])

  // Simple debounce implementation
  const debounce = (fn, delay) => {
    let timer
    return (...args) => {
      clearTimeout(timer)
      timer = setTimeout(() => fn(...args), delay)
    }
  }
  const onChange = debounce((val) => {
    setGlobalFilter(val || undefined)
  }, 200)

  return (
    <span className="bg-light- col input-group-text">
      <div className="pr-3">
        <strong>{totalResults} total results</strong>
      </div>
      <input
        className="border"
        value={value || ''}
        onChange={(e) => {
          setValue(e.target.value)
          onChange(e.target.value)
        }}
        placeholder={`Search table below...`}
        style={{
          fontSize: '1.1rem',
          border: '0',
        }}
      />
    </span>
  )
}
